import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { fetchSubscriptionByToken } from "../api/subscriptionsApi";
import { cycleLabel, formatMoney, typeLabel } from "../utils/pricing";
import "./css/pricing.css";

export default function SubscribeSuccessPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(Boolean(token));

  useEffect(() => {
    let on = true;
    if (!token) {
      setLoading(false);
      return undefined;
    }
    (async () => {
      try {
        const data = await fetchSubscriptionByToken(token);
        if (on) setSubscription(data);
      } catch {
        if (on) setSubscription(null);
      } finally {
        if (on) setLoading(false);
      }
    })();
    return () => {
      on = false;
    };
  }, [token]);

  if (loading) {
    return (
      <div className="cl-pricing-loading">
        <Spin />
      </div>
    );
  }

  const paid = subscription?.payment_status === "paid";
  const customer = subscription?.customer || {};

  return (
    <section className="cl-checkout">
      <div className="cl-container cl-success">
        <p className="cl-eyebrow">{paid ? "Payment confirmed" : "Subscription saved"}</p>
        <h1>{paid ? "Your plan is active" : "We could not confirm payment yet"}</h1>
        {subscription && (
          <div className="cl-checkout-card cl-success-card">
            <p>
              <strong>{subscription.package_name}</strong> · {typeLabel(subscription.subscription_type)} ·{" "}
              {cycleLabel(subscription.billing_cycle)}
            </p>
            <p>{formatMoney(subscription.price, subscription.currency)}</p>
            <p>
              {customer.first_name} {customer.last_name} · {customer.email}
            </p>
            <p>
              Status: <strong>{(subscription.payment_status || "unpaid").toUpperCase()}</strong>
            </p>
            {paid && (
              <p>
                This is a recurring {cycleLabel(subscription.billing_cycle).toLowerCase()} subscription.
                Your card will be charged again at the start of the next billing period unless the
                subscription is cancelled in Stripe.
              </p>
            )}
          </div>
        )}
        {!paid && token && (
          <p>
            If you already paid, wait a moment and refresh. You can also{" "}
            <Link to={`/subscribe/payment/${token}`}>return to payment</Link>.
          </p>
        )}
        <Link to="/" className="btn btn-solid">
          Back to home
        </Link>
      </div>
    </section>
  );
}
